module.exports = __webpack_public_path__ + "img/top_gun_2022.99610efb.jpg";